import {
    ComponentCategory,
    ComponentElementManifest
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import { DefaultLayoutId } from "@bizform/type/model/component_element/DefaultLayoutId.model";
import { PluginType } from "@bizform/type/model/model/Plugin.model";
import { BfButton } from "../bf_component/button/BfButton";

/**
 * Button component element
 *
 * @since 0.0.1
 * @author Heungsoo Ham
 * @class
 */
export class BfWihAction extends BfButton {
    static readonly pluginType: string = PluginType.WIHACTIONHANDLER;

    /* manifest */
    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_c3dIwW__cKOc66T6VV3EQgeRNE4Nz1s",
        category: ComponentCategory.HANDLER,
        defaultLayoutId: DefaultLayoutId.ONLYCOMPONENTELEMENT,
        label: "WIH Action Caller",
        description: "WIH Action Caller",
        icon: "",
        property: null
    };
}
